import React, { useEffect, useState } from 'react'
import { compare, formatCash } from 'utils'
import moment from 'moment'

//components
import TitlePage from 'components/title-page'

//antd
import {
  Button,
  Row,
  Table,
  Switch,
  notification,
  Form,
  InputNumber,
  Input,
  Modal,
  Popconfirm,
  Space,
  Select,
  Typography,
} from 'antd'

//icons
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons'
import { getCountries } from 'apis/country'
//apis
import {
  getToppingCategoryList,
  getToppingList,
  addToppingCategory,
  addTopping,
  updateTopping,
  deleteTopping,
} from 'apis/topping'

export default function Topping() {
  const [form] = Form.useForm()

  const [toppingList, setToppingList] = useState([])
  const [countries, setCountries] = useState([])
  const [countTopping, setCountTopping] = useState(0)
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: 20 })
  const [record, setRecord] = useState(null)
  const [btnLoading, setBtnLoading] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  const [toppingCategoryList, setToppingCategoryList] = useState([])
  const [loading, setLoading] = useState(false)
  const [nameToppingCategory, setNameToppingCategory] = useState('')

  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)

  const _getToppingList = async () => {
    try {
      setTableLoading(true)
      const res = await getToppingList({ ...paramsFilter })
      if (res.status === 200) {
        setToppingList(res.data.data)
        setCountTopping(res.data.count)
      }
      setTableLoading(false)
    } catch (err) {
      setTableLoading(false)
      console.log(err)
    }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const _updateTopping = async (body, id) => {
    try {
      setTableLoading(true)
      const res = await updateTopping(id, body)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Cập nhật thành công' })
          _getToppingList()
        } else
          notification.error({
            message: res.data.message || 'Cập nhật không thành công, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Cập nhật không thành công, vui lòng thử lại',
        })
      setTableLoading(false)
    } catch (error) {
      setTableLoading(false)
    }
  }

  const onDeleteTopping = async (id) => {
    try {
      const res = await deleteTopping([id])
      if (res.status === 200) {
        notification.success({ message: 'Xóa topping thành công' })
        _getToppingList()
      } else {
        notification.error({ message: res.data.message || 'Xóa topping không thành công' })
      }
    } catch (err) {
      console.log(err)
      notification.error({ message: 'Xóa topping không thành công!' })
    }
  }
  const columns = [
    {
      title: 'STT',
      render(data, record, index) {
        return (paramsFilter.page - 1) * paramsFilter.page_size + index + 1
      },
    },
    {
      title: 'Quốc gia',
      dataIndex: 'country_info',
      render(data, record, index) {
        return <div>{record.country_info && record.country_info.name}</div>
      },
    },
    {
      title: 'Mã topping',
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: 'Tên topping',
      dataIndex: 'name',
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      title: 'Loại topping',
      render: (text, record) =>
        record.topping_category_info &&
        record.topping_category_info.map((topping) => topping.name).join(', '),
    },
    {
      title: 'Giá',
      dataIndex: 'price',
      sorter: (a, b) => compare(a, b, 'price'),
      render(data) {
        return formatCash(data || 0)
      },
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      render(data) {
        return data && moment(data).format('DD/MM/YYYY HH:mm')
      },
    },
    {
      title: 'Hành động',
      render(data, record) {
        return (
          <Space size="middle">
            <Switch
              checked={record.is_active}
              onClick={() => _updateTopping({ is_active: !record.is_active }, record.topping_id)}
            />

            <EditOutlined
              onClick={() => {
                setRecord(record)
                toggle()
              }}
              style={{ color: 'blue', cursor: 'pointer', fontSize: 17 }}
            />

            <Popconfirm
              title="Bạn muốn xóa topping này không?"
              okText="Xác nhận"
              cancelText="Hủy"
              onConfirm={() => onDeleteTopping(data.topping_id)}
            >
              <DeleteOutlined style={{ color: 'red', cursor: 'pointer', fontSize: 17 }} />
            </Popconfirm>
          </Space>
        )
      },
    },
  ]

  const _getToppingCategoryList = async () => {
    try {
      const res = await getToppingCategoryList()
      if (res.status === 200) setToppingCategoryList(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  const _addToppingCategory = async () => {
    try {
      setLoading(true)
      const res = await addToppingCategory({ name: nameToppingCategory })
      if (res.status === 200) {
        if (res.data.success) {
          setNameToppingCategory('')
          _getToppingCategoryList()
          notification.success({ message: 'Thêm loại topping thành công' })
        } else notification.error({ message: 'Thêm loại topping thất bại, vui lòng thử lại' })
      } else notification.error({ message: 'Thêm loại topping thất bại, vui lòng thử lại' })
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _addOrUpdateTopping = async (formData) => {
    try {
      setBtnLoading(true)
      let res
      const body = { ...formData, min_quantity: 1, max_quantity: 999 }
      if (record) res = await updateTopping(record.topping_id, body)
      else res = await addTopping(body)

      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: `${record ? 'Cập nhật' : 'Thêm'} topping thành công` })
          _getToppingList()
          form.resetFields()
          toggle()
        } else
          notification.error({
            message: res.data.message || `${record ? 'Cập nhật' : 'Thêm'} topping không thành công`,
          })
      } else
        notification.error({
          message: res.data.message || `${record ? 'Cập nhật' : 'Thêm'} topping không thành công`,
        })
      setBtnLoading(false)
    } catch (err) {
      console.log(err)
      setBtnLoading(false)
    }
  }

  useEffect(() => {
    if (visible) {
      if (record) form.setFieldsValue({ ...record })
    } else form.resetFields()
  }, [visible])

  useEffect(() => {
    _getToppingCategoryList()
    _getCountries()
  }, [])

  useEffect(() => {
    _getToppingList()
  }, [paramsFilter])

  return (
    <div
      style={{
        boxShadow: ' 0 12px 23px 0 #5c37990a',
        borderRadius: '1.25rem',
        background: '#fff',
        margin: '1rem',
        padding: '1rem',
      }}
    >
      <Modal
        title={record ? 'Cập nhật topping' : 'Thêm topping'}
        visible={visible}
        onCancel={toggle}
        footer={false}
        width="60%"
      >
        <Form
          onFinish={_addOrUpdateTopping}
          form={form}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          labelAlign="left"
        >
          <Form.Item
            name="country_id"
            label="Quốc gia"
            rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
          >
            <Select placeholder="Chọn quốc gia" optionFilterProp="children" showSearch>
              {countries.map((country, index) => (
                <Select.Option value={country.country_id} key={index}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="name"
            label="Tên topping"
            rules={[{ required: true, message: 'Vui lòng nhập tên topping' }]}
          >
            <Input placeholder="Nhập tên topping" />
          </Form.Item>
          <Form.Item
            name="topping_category_ids"
            label="Loại topping"
            rules={[{ required: true, message: 'Vui lòng chọn loại topping' }]}
          >
            <Select
              mode="multiple"
              maxTagCount="responsive"
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Chọn loại topping"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Space align="center" style={{ padding: '0 8px 4px', width: '100%' }}>
                    <Input
                      onPressEnter={_addToppingCategory}
                      style={{ width: '100%' }}
                      placeholder="Nhập tên loại topping"
                      value={nameToppingCategory}
                      onChange={(e) => setNameToppingCategory(e.target.value)}
                    />
                    <Typography.Link
                      onClick={(e) => {
                        e.preventDefault()
                        if (nameToppingCategory) _addToppingCategory()
                      }}
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      {loading ? <LoadingOutlined /> : <PlusOutlined />} Thêm
                    </Typography.Link>
                  </Space>
                </>
              )}
            >
              {toppingCategoryList.map((topping, index) => (
                <Select.Option key={index} value={topping.topping_category_id}>
                  {topping.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="price"
            label="Giá"
            rules={[{ required: true, message: 'Vui lòng nhập giá' }]}
          >
            <InputNumber
              min={0}
              placeholder="Nhập giá topping"
              style={{ width: '100%' }}
              formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
            />
          </Form.Item>

          <Row justify="end">
            <Button type="primary" htmlType="submit" loading={btnLoading}>
              {record ? 'Cập nhật' : 'Thêm'}
            </Button>
          </Row>
        </Form>
      </Modal>

      <TitlePage title="Topping">
        <Button onClick={toggle} size="large" type="primary" icon={<PlusCircleOutlined />}>
          Thêm topping
        </Button>
      </TitlePage>
      <Table
        columns={columns}
        dataSource={toppingList}
        size="small"
        loading={tableLoading}
        pagination={{
          position: ['bottomLeft'],
          current: paramsFilter.page,
          defaultPageSize: 20,
          pageSizeOptions: [20, 30, 40, 50, 60, 70, 80, 90, 100],
          showQuickJumper: true,
          onChange: (page, pageSize) =>
            setParamsFilter({ ...paramsFilter, page: page, page_size: pageSize }),
          total: countTopping,
        }}
      />
    </div>
  )
}
